import { create } from "zustand";

interface FilterState {
  filters: Record<string, any>;
  setFilters: (filters: FilterState["filters"]) => void;
  resetFilters: () => void;
}

const defaultFilters: FilterState["filters"] = {
  locationDestination: { value: "", matchMode: "contains" },
  locationOrigin: { value: "", matchMode: "contains" },
  employeeName: { value: "", matchMode: "contains" },
  status: { value: "", matchMode: "contains" },
};

export const useFilterSupportTripStore = create<FilterState>((set) => ({
  filters: defaultFilters,
  setFilters: (filters) => set({ filters }),
  resetFilters: () => set({ filters: defaultFilters }),
}));
